import { mapDomain, tokenApiBaseUrl } from '.'

/* eslint-disable camelcase */
export type AuthToken = {
  access_token: string
  expires_in: number
  id_token: string
  scope: string
  token_type: string
}
/* eslint-enable camelcase */

export const getAuthToken = async (): Promise<AuthToken> => {
  return await fetch(`${tokenApiBaseUrl}/exchange/accountconsent`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
  }).then((res) => {
    if (res.ok) return res.json()
    throw new Error(res.statusText)
  })
}

// Only for testing purposes
export type AuthTokenTest = {
  accessToken: string
  expiresIn: number
  identityToken: string
  refreshToken: string
  tokenType: string
}

export const getAuthTokenOnTest = async (): Promise<AuthTokenTest> => {
  return await fetch(`https://testauth.${mapDomain(MH_BRAND)}/OIDC/Login`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({}),
  }).then((res) => {
    if (res.ok) return res.json()
    throw new Error(res.statusText)
  })
}
